import { __rest } from "tslib";
import React, { createContext, useContext } from 'react';
import client from './client';
export var ClientContext = createContext(undefined);
var Provider = ClientContext.Provider;
export var ClientProvider = function (_a) {
    var children = _a.children, config = __rest(_a, ["children"]);
    return React.createElement(Provider, { value: client(config) }, children);
};
export var useClient = function () {
    var context = useContext(ClientContext);
    if (!context) {
        throw new Error('The GraphQL client provider was not correctly instantiated.');
    }
    return context;
};
//# sourceMappingURL=Provider.js.map